import react, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText'; 
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import { constants } from '../../util'
import { useSelector, useDispatch } from 'react-redux';
import { showSignup, showWaiting } from '../../store/slices/configSlice';
import { setAuthenticated, setProfilePhoto, setIsFullProfile, setIsFirstAccess } from '../../store/slices/userSlice';
import WizardCreateAccount from '../../components/util/WizardCreateAccount';
import { login } from '../../services/securityService';

import { useTranslation } from 'react-i18next';
import i18next from 'i18next'

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'
import { enqueueSnackbar } from 'notistack';

import GoogleSignIn from '../../components/auth/GoogleSignIn';
import { getCountries } from '../../services/CatalogService';
import { isValidCode, register, sendVerificationCode } from '../../services/registrationService';

const Root = styled('div')(({ theme }) => ({
  width: '100%',
  ...theme.typography.body2,
  color: (theme.vars || theme).palette.text.secondary,
  '& > :not(style) ~ :not(style)': {
    marginTop: theme.spacing(2),
  },
}));





export default function Signup() {
    const navigate = useNavigate();
    const {language, openSignup} = useSelector(state => state.configuration);
    const dispatch = useDispatch();
    const [step, setStep] = useState(0);
    const [countries, setCountries] = useState([]);
    const [errorValidations, setErrorValidations] = useState([]);
    
    const [artist, setArtist] = useState({
        name: '',
        company: '',
        originCountry: '',
        email: '',
        emailConfirm: '',
        phone: '',
        urlTiktok: '',
        urlSpotify: '',
        urlAppleMusic: '',
        password: '',
        passwordConfirm: '',
    });

    //TRANSLATION
    const [t, i18n] = useTranslation("global");



    const sch1 = (yup) => yup.object({
        name: yup.string().required().min(3).max(40),
        company: yup.string().required().min(3).max(40),
        originCountry: yup.string().required(),
    });
    const personalSchema = useYupSchema(sch1);

    const sch2 = (yup) => yup.object({
        email: yup.string().required().email().min(6).max(40), 
        emailConfirm: yup.string().required().email().min(6).max(40), 
        phone: yup.string().matches(/^[0-9]+$/, t("validations.onlyNumbers")).required().min(10).max(13),
    });
    const contactSchema = useYupSchema(sch2);

    const sch3 = (yup) => yup.object({
        urlTiktok: yup.string().url().required().min(10).max(150), 
        urlSpotify: yup.string().url().required().min(10).max(150), 
        urlAppleMusic: yup.string().url().required().min(10).max(150), 
    });
    const socialSchema = useYupSchema(sch3);

    const sch4 = (yup) => yup.object({
        verificationCode: yup.string().required().min(6).max(6)
    });
    const verificationSchema = useYupSchema(sch4);

    const sch5 = (yup) => yup.object({
        password: yup.string().required().min(6).max(20), 
        passwordConfirm: yup.string().required().min(6).max(20), 
    });
    const passwordSchema = useYupSchema(sch5);


    const handleClose = () => {
        dispatch(showSignup(false));
        setStep(0);
        resetPersonal();
        resetContact();
        resetSocial();
        resetVerification();
        resetPassword();

        setArtist({
            name: '',
            company: '',
            originCountry: '',
            mail: '',
            mailConfirm: '',
            phone: '',
            urlTiktok: '',
            urlSpotify: '',
            urlAppleMusic: '',
            password: '',
            passwordConfirm: '',
        });
    }

    const handlePrev = () => {
        if (step-1 >= 0)
            setStep(step-1)
        else
            setStep(5)
    }
    
    const handleContinue = () => {
        if (step+1 <= 5)
            setStep(step+1)
        else
            setStep(0)
    }

    const steps = [
        {
            step: 0,
            text: t("signUp.textStep1"),
            imgKey: 'guitar-02.svg'
        },
        {
            step: 1,
            text: t("signUp.textStep2"),
            imgKey: 'guitar-03.svg'
        },
        {
            step: 2,
            text: t("signUp.textStep3"),
            imgKey: 'guitar-04.svg'
        },
        {
            step: 3,
            text: t("signUp.textStep4"),
            imgKey: 'guitar-05.svg'
        },
        {
            step: 4,
            text: t("signUp.textStep5"),
            imgKey: 'guitar-06.svg'
        },
        {
            step: 5,
            text: '',
            imgKey: 'guitar-07.svg'
        }
    ];


    const { control, register: registerPersonal, handleSubmit: handleSubmit_Personal, reset: resetPersonal, setFocus: setFocusPersonal, formState: { errors: errorsPersonal } } = useForm({
                resolver: yupResolver(personalSchema),
                defaultValues: {
                    originCountry: '' // cadena vacía en lugar de undefined
                }
            });

    const { register: registerContact, handleSubmit: handleSubmit_Contact, reset: resetContact, setFocus: setFocusContact, formState: { errors: errorsContact } } = useForm({
                resolver: yupResolver(contactSchema),
            });

    const { register: registerSocial, handleSubmit: handleSubmit_Social, reset: resetSocial, setFocus: setFocusSocial, formState: { errors: errorsSocial } } = useForm({
                resolver: yupResolver(socialSchema),
            });
    
    const { register: registerVerification, handleSubmit: handleSubmit_Verification, reset: resetVerification, setFocus: setFocusVerification, formState: { errors: errorsVerification } } = useForm({
        resolver: yupResolver(verificationSchema),
    });

    const { register: registerPassword, handleSubmit: handleSubmit_Password, reset: resetPassword, setFocus: setFocusPassword, formState: { errors: errorsPassword } } = useForm({
        resolver: yupResolver(passwordSchema),
    });
    
    
            
    const onSubmit_Personal = (data) => {
        dispatch(showWaiting(true));
        setArtist({
            ...artist,
            name: data.name,
            company: data.company,
            originCountry: data.originCountry,
        });
        
        setTimeout(() => {
            handleContinue();
            dispatch(showWaiting(false));
        }, 500);
    }

    const onSubmit_Contact = (data) => {
        dispatch(showWaiting(true));
        setTimeout(() => {
            if (data.email===data.emailConfirm)
            {
                setArtist({
                    ...artist,
                    email: data.email,
                    emailConfirm: data.emailConfirm,
                    phone: data.phone,
                });

                handleContinue();
            }
            else
                enqueueSnackbar(language==='es'
                    ? 'Los correos no coinciden'
                        : 'Emails are not equal', { variant: 'error', persist: false });
            
            dispatch(showWaiting(false));
        }, 500);
    }

    const onSubmit_Social = (data) => {
        dispatch(showWaiting(true));
        setArtist({
            ...artist,
            urlTiktok: data.urlTiktok,
            urlSpotify: data.urlSpotify,
            urlAppleMusic: data.urlAppleMusic,
        });

        sendVerificationCode(artist.email)
            .then(rsp => {
                setTimeout(() => {
                    if (rsp.code === '00')
                        handleContinue();
                    else
                        enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                
                    dispatch(showWaiting(false));
                }, 500);
            });
    }

    const onSubmit_Verification = (data) => {
        dispatch(showWaiting(true));
        setArtist({
            ...artist,
            verificationCode: data.verificationCode,
        });

        isValidCode(artist.email, data.verificationCode)
            .then(rsp => {
                setTimeout(() => {
                    if (rsp.code === '00')
                        handleContinue();
                    else
                        enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                
                    dispatch(showWaiting(false));
                }, 500);
            });
    }

    const onSubmit_Password = (data) => {
        dispatch(showWaiting(true));
        
        setArtist({
            ...artist,
            password: data.password,
            passwordConfirm: data.passwordConfirm,
        });

        if (data.password === data.passwordConfirm){
            const arrValidations = validatePassword(data.password);
            if (arrValidations.length > 0){
                setErrorValidations(arrValidations);
                dispatch(showWaiting(false));
            }
            else{
                setErrorValidations([]);
                register({
                        ...artist, 
                        password: data.password
                    })
                    .then(rsp => {
                        setTimeout(() => {
                            if (rsp.code === '00')
                                handleContinue();
                            else
                                enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                            dispatch(showWaiting(false));
                        }, 500);
                    });
                
            }
        }
        else{
            setTimeout(() => {
                dispatch(showWaiting(false));
                enqueueSnackbar(
                    language==='es'
                        ? 'Las contraseñas no coinciden'
                        : 'Passwords are not equal'
                , { variant: 'error', persist: false });
            }, 500);
        }
    }

    
    useEffect(() => {
        getCountries()
            .then(rsp => {
                if (rsp.code === '00')
                    setCountries(rsp.metadata.countries);
                else
                {
                    setCountries([]);
                    enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                }
            });
    }, []);


    const handleClick_Start = () => {
        dispatch(showWaiting(true));
        login(artist.email, artist.password)
            .then(rsp => {
                if (rsp.code === '00'){
                    setTimeout(() => {
                        dispatch(setAuthenticated(rsp.metadata?.token))
                        dispatch(setProfilePhoto(rsp.metadata?.profilePhoto));
                        dispatch(setIsFullProfile(rsp.metadata?.isFullProfile));
                        dispatch(setIsFirstAccess(rsp.metadata?.isFirstAccess));
                        dispatch(showSignup(false));
                    
                        
                        enqueueSnackbar(rsp.message, { variant: 'success', persist: false });
                        dispatch(showWaiting(false));
                        // reset();

                        navigate('/index');
                    }, 1500);
                }
                else{
                    dispatch(showWaiting(false));
                    enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                }
            })
            .catch(err => {
                dispatch(showWaiting(false));
                enqueueSnackbar(err, { variant: 'error', persist: false });
            });
    }


    const handleClick_ResendCode = () => {
        sendVerificationCode(artist.email)
            .then(rsp => {
                setTimeout(() => {
                    if (rsp.code === '00')
                        enqueueSnackbar(
                            language==='es'
                                ? 'El código de verificacion ha sido enviado exitosamente.'
                                : 'Your new verification code has been sent successfully.'
                            , { variant: 'success', persist: false });
                    else
                        enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                
                    dispatch(showWaiting(false));
                }, 500);
            });
    }


    const validatePassword = (pwd) => {
        const rules = [
            { test: pwd.length >= 8 && pwd.length <= 15, message: language==='es' ? 'La contraseña debe tener entre 8 y 15 caracteres' : 'Password must have between 8 and 15 characters' },
            { test: /[A-Z]/.test(pwd), message: language==='es' ? 'Debe incluir al menos 1 mayúscula' : 'Must include at least 1 capital letter' },
            { test: /[a-z]/.test(pwd), message: language==='es' ? 'Debe incluir al menos 1 minúscula' : 'Must include at least 1 lowercase letter' },
            { test: /\d/.test(pwd), message: language==='es' ? 'Debe incluir al menos 1 número' : 'Must include at least 1 number' },
            { test: /[*.,\-_/()%$#]/.test(pwd), message: language==='es' ? 'Debe incluir al menos 1 símbolo (*.,-_/()%$#)' : 'Must include at least 1 symbol (*.,-_/()%$#)' },
        ];

        return rules.filter(rule => !rule.test);
    };

    const onChangePassword = (e) => {
        
        setErrorValidations([]);
    }



    return(
        <>
            <Modal
                open={openSignup}
                onClose={()=>handleClose()}
            >
                
                    <Box sx={{ ...constants.styles.modalBox,
                        width: {
                            sxs: '95%', 
                            xs: '95%',  // Celular-vertical
                            sm: '85%',  // Ipad Vertical
                            md: '60%',  // Ipad Horizontal
                            lg: '65%',  // Laptop-PC
                            xl: '65%',  // Laptop-PC,
                        },
                        maxwidth: {
                            sxs: '400px', 
                            xs: '400px',  // Celular-vertical
                            sm: '700px',  // Ipad Vertical
                            md: '700px',  // Ipad Horizontal
                            lg: '700px',  // Laptop-PC
                            xl: '700px',  // Laptop-PC,
                        },
                        height:  '97%',
                        minHeight: '350px',
                        maxHeight: '570px',
                        
                    }}
                    >
                        <Grid container spacing={0} sx={{height: '100%'}}>
                            <Grid size={{sxs: 0, xs:0, sm:5, md:5, lg:5, xl:5}} 
                                sx={{ display: {sxs: 'none', xs:'none', sm:'block', md:'block', lg:'block', xl:'block'},
                                    height: '100%',
                                    backgroundImage: `url(/assets/img/generic/${steps[step].imgKey})`,
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    backgroundSize: "cover",
                                    borderTopLeftRadius: 12,
                                    borderBottomLeftRadius: 12
                                }}
                            >
                            </Grid>
                            
                            <Grid container direction="column" spacing={0} size={{sxs:12, xs:12, sm:7, md:7, lg:7, xl:7}} 
                                sx={{
                                    paddingLeft: '25px',
                                    paddingRight: '25px',
                                    paddingTop: '15px',
                                    paddingBottom: '15px',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    // alignItems: "center",
                                }}
                            >
                                <Box sx={{display: 'flex', flexDirection: 'column',  width: '100%', flex:'1', overflow: 'auto'}}>
                                    <div style={{display: (step===5 ? 'none': 'block')}}>
                                        <Grid container direction={'column'} size={12} sx={{alignContent: 'center', marginBottom: '20px'}}>
                                            <Typography sx={{fontWeight: 'bold', fontSize: '20px'}}>{t("signUp.title")}</Typography>
                                        </Grid>
                                        <Grid container direction={'column'} size={12} sx={{alignContent: 'center', marginBottom: '50px'}}>
                                            <WizardCreateAccount step={step} text={steps[step].text} />
                                        </Grid>
                                    </div>
                                    <Grid container direction={'column'} size={12} sx={{alignContent: 'center', flex:'1'}}>
                                        <div id="paso1" style={{ display: (step===0 ? 'block': 'none'), flex:'1', width:'100%'}}>
                                            <form onSubmit={handleSubmit_Personal(onSubmit_Personal)}
                                                style={{
                                                    width:'100%',
                                                    height:'100%',
                                                    display:'flex',
                                                    flexDirection:'column',
                                                }}
                                            >
                                                <TextField id="txtName" label={t("signUp.name")} variant="outlined" margin="normal" autoFocus fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                                    {...registerPersonal('name')}
                                                    error={!!errorsPersonal.name}
                                                    helperText={errorsPersonal.name?.message}
                                                />
                                                <TextField id="txtCompany" label={t("signUp.company")} variant="outlined" margin="dense" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}}
                                                    {...registerPersonal('company')}
                                                    error={!!errorsPersonal.company}
                                                    helperText={errorsPersonal.company?.message}
                                                />
                                                <Controller
                                                    name="originCountry"
                                                    control={control}
                                                    render={({ field }) => (
                                                    <FormControl fullWidth error={!!errorsPersonal.originCountry}>
                                                        <InputLabel id="country-label">{t("signUp.country")}</InputLabel>
                                                        <Select
                                                            {...field}
                                                            labelId="country-label"
                                                            label={t("signUp.country")}
                                                            sx={{ width: '100%', marginBottom: '0px' }}
                                                        >
                                                            {
                                                                countries?.map(e => (
                                                                    <MenuItem value={e.id}>
                                                                        <Box display="flex" alignItems="center" gap={1}>
                                                                            <img
                                                                                src={`/assets/img/flags/${e.flagKey}.svg`}
                                                                                alt={e.name}
                                                                                style={{ width:'18px', height:'13px' }}
                                                                            />
                                                                            <Typography>{e.name}</Typography>
                                                                        </Box>
                                                                    </MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                        <FormHelperText>
                                                            {errorsPersonal.originCountry?.message}
                                                        </FormHelperText>
                                                    </FormControl>
                                                    )}
                                                />
                                                <div style={{flex:'1'}}></div>
                                                <Button type='submit' variant="text" sx={{ ...constants.styles.secondaryButton, alignSelf: 'flex-end', marginTop:'auto' }} >{t("signUp.nextButton")}</Button>
                                            </form>
                                        </div>
                                        <div id="paso2" style={{display: (step===1 ? 'block': 'none'), width:'100%', flex:'1'}}>
                                            <form onSubmit={handleSubmit_Contact(onSubmit_Contact)}
                                                style={{
                                                        width:'100%',
                                                        height:'100%',
                                                        display:'flex',
                                                        flexDirection:'column',
                                                    }}
                                            >
                                                <TextField id="txtEmail" label={t("signUp.email")} variant="outlined" autoFocus margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                                    {...registerContact('email')}
                                                    error={!!errorsContact.email}
                                                    helperText={errorsContact.email?.message}
                                                />
                                                <TextField id="txtEmailConfirm" label={t("signUp.emailConfirm")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                                    {...registerContact('emailConfirm')}
                                                    error={!!errorsContact.emailConfirm}
                                                    helperText={errorsContact.emailConfirm?.message}
                                                />
                                                <TextField id="txtPhone" label={t("signUp.phone")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                                    {...registerContact('phone')}
                                                    error={!!errorsContact.phone}
                                                    helperText={errorsContact.phone?.message}
                                                />
                                                <div style={{flex:'1'}}></div>
                                                <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
                                                    <Button variant="text" sx={{ ...constants.styles.secondaryButton, marginRight:'5px' }} onClick={()=>handlePrev()}>{t("signUp.prevButton")}</Button>
                                                    <Button type='submit' variant="text" sx={{ ...constants.styles.secondaryButton, marginLeft:'5px' }} >{t("signUp.nextButton")}</Button>
                                                </div>
                                            </form>
                                        </div>
                                        <div id="paso3" style={{display: (step===2 ? 'block': 'none'), width:'100%', flex:'1'}}>
                                            <form onSubmit={handleSubmit_Social(onSubmit_Social)}
                                                style={{
                                                        width:'100%',
                                                        height:'100%',
                                                        display:'flex',
                                                        flexDirection:'column',
                                                    }}
                                            >
                                                <TextField id="txtTiktok" label={t("signUp.tiktok")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                                    {...registerSocial('urlTiktok')}
                                                    error={!!errorsSocial.urlTiktok}
                                                    helperText={errorsSocial.urlTiktok?.message}
                                                />
                                                <TextField id="txtSpotify" label={t("signUp.spotify")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                                    {...registerSocial('urlSpotify')}
                                                    error={!!errorsSocial.urlSpotify}
                                                    helperText={errorsSocial.urlSpotify?.message}
                                                />
                                                <TextField id="txtApple" label={t("signUp.apple")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                                    {...registerSocial('urlAppleMusic')}
                                                    error={!!errorsSocial.urlAppleMusic}
                                                    helperText={errorsSocial.urlAppleMusic?.message}
                                                />
                                                <div style={{flex:'1'}}></div>
                                                <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
                                                    <Button variant="text" sx={{ ...constants.styles.secondaryButton, marginRight:'5px' }} onClick={()=>handlePrev()}>{t("signUp.prevButton")}</Button>
                                                    <Button type='submit' variant="text" sx={{ ...constants.styles.secondaryButton, marginLeft:'5px' }} >{t("signUp.nextButton")}</Button>
                                                </div>
                                            </form>
                                        </div>
                                        <div id="paso4" style={{display: (step===3 ? 'block': 'none'), width:'100%', flex:'1'}}>
                                            <form onSubmit={handleSubmit_Verification(onSubmit_Verification)}
                                                style={{
                                                        width:'100%',
                                                        height:'100%',
                                                        display:'flex',
                                                        flexDirection:'column',
                                                    }}
                                            >
                                                <Typography sx={{fontSize: '11px'}}>{t("signUp.descVerificationCode")}</Typography>
                                                <br />
                                                <TextField id="txtVerificactionCode" label={t("signUp.verificationCode")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                                    {...registerVerification('verificationCode')}
                                                    error={!!errorsVerification.verificationCode}
                                                    helperText={errorsVerification.verificationCode?.message}
                                                />
                                                <Button variant="text" sx={{ ...constants.styles.linkButton, fontSize: '11px', width:'fit-content'}} onClick={()=>handleClick_ResendCode()}>{t("signUp.sendVerificationCode")}</Button>
                                                <div style={{flex:'1'}}></div>
                                                <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
                                                    <Button variant="text" sx={{ ...constants.styles.secondaryButton, marginRight:'5px' }} onClick={()=>handlePrev()}>{t("signUp.prevButton")}</Button>
                                                    <Button type='submit' variant="text" sx={{ ...constants.styles.secondaryButton, marginLeft:'5px' }} >{t("signUp.nextButton")}</Button>
                                                </div>
                                            </form>
                                        </div>
                                        <div id="paso5" style={{display: (step===4 ? 'block': 'none'), width:'100%', flex:'1'}}>
                                            <form onSubmit={handleSubmit_Password(onSubmit_Password)}
                                                style={{
                                                        width:'100%',
                                                        height:'100%',
                                                        display:'flex',
                                                        flexDirection:'column',
                                                    }}
                                            >
                                                <TextField id="txtPassword" label={t("signUp.password")} type="password" autoComplete="current-password" variant="outlined" margin="dense" fullWidth  
                                                    // onChange={(e) =>
                                                    //     {
                                                    //         onChange(e);
                                                    //         onChangePassword(e);
                                                    //     }
                                                    // }
                                                    {...registerPassword('password')}
                                                    error={!!errorsPassword.password}
                                                    helperText={errorsPassword.password?.message}
                                                />
                                                <TextField id="txtPasswordConfirm" label={t("signUp.passwordConfirm")} type="password" autoComplete="current-password" variant="outlined" margin="dense" fullWidth  
                                                    // onChange={onChangePassword}
                                                    {...registerPassword('passwordConfirm')}
                                                    error={!!errorsPassword.passwordConfirm}
                                                    helperText={errorsPassword.passwordConfirm?.message}
                                                />
                                                {
                                                    errorValidations.map(error => (
                                                        <Typography key={error.message} sx={{color:'red', fontSize:'12px'}}>{error.message}</Typography>
                                                    ))
                                                }
                                                <div style={{flex:'1'}}></div>
                                                <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
                                                    <Button variant="text" sx={{ ...constants.styles.secondaryButton, marginRight:'5px' }} onClick={()=>handlePrev()}>{t("signUp.prevButton")}</Button>
                                                    <Button type='submit' variant="text" sx={{ ...constants.styles.secondaryButton, marginLeft:'5px' }} >{t("signUp.nextButton")}</Button>
                                                </div>
                                            </form>
                                        </div>
                                        <div id="paso6" style={{display: (step===5 ? 'block': 'none'), width:'100%', flex:'1'}}>
                                            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', width: '100%', height:'100%'}}>
                                                <img src="/assets/img/logo/logo-black.svg" style={{width: '60%'}} />
                                                <br /><br /><br />
                                                {
                                                    language == 'es' ?
                                                        <img src={`/assets/img/generic/felicidades.png`} style={{width: '70%'}} />
                                                    :
                                                        null
                                                }
                                                {
                                                    language == 'en' ?
                                                        <img src={`/assets/img/generic/congrats.png`} style={{width: '70%'}} />
                                                    :
                                                        null
                                                }
                                                <br />
                                                <Typography sx={{fontSize:'12px'}}>{t("signUp.descCongrats_1")}</Typography>
                                                <br />
                                                <Typography sx={{fontSize:'12px'}}>{t("signUp.descCongrats_2")}</Typography>
                                                {/* <br /><br /><br /> */}
                                                <div style={{flex:'1'}}></div>
                                                <Button variant="text" sx={{ ...constants.styles.mainButton, alignSelf: 'flex-end' }} onClick={()=>handleClick_Start()}>{t("signUp.finalButton")}</Button>
                                            </Box>
                                        </div>
                                    </Grid>
                                </Box>
                                {/* <Box sx={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: "center", alignItems: "stretch",}}>
                                    <div style={{display: (step!=5 && step!=0 ? 'block': 'none'), width: '100%', paddingRight: '5px'}}>
                                        <Button variant="text" sx={{ ...constants.styles.secondaryButton, alignSelf: 'flex-end' }} onClick={()=>handlePrev()}>{t("signUp.prevButton")}</Button>
                                    </div>
                                    <div style={{display: (step!=5 ? 'block': 'none'), width: '100%', paddingLeft: '5px'}}>
                                        <Button variant="text" sx={{ ...constants.styles.secondaryButton, alignSelf: 'flex-end' }} onClick={()=>handleClick_Next()} >{t("signUp.nextButton")}</Button>
                                    </div>
                                    <div style={{display: (step===5 ? 'block': 'none'), width: '100%'}}>
                                        <Button variant="text" sx={{ ...constants.styles.mainButton, alignSelf: 'flex-end' }} onClick={()=>handleClose()}>{t("signUp.finalButton")}</Button>
                                    </div>
                                </Box> */}
                                    
                                    
                                    
                                    {/* <div class="g-signin2" data-width="300" data-height="200" data-longtitle="true" /> */}
                                
                                
                            </Grid>
                        </Grid>
                    </Box>
            </Modal>
        </>
    )
}
